import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import {
  getTermsAndConditions as getTermsAndConditionsService,
  updateTermsAndConditions as updateTermsAndConditionsService,
} from "../../services/TermsAndConditionsService";
import {
  TermsAndConditions,
  TermsAndConditionsState,
} from "../../interfaces/terms-and-conditions-interface";

export const getTermsAndConditions = createAsyncThunk(
  "termsAndConditions/getTermsAndConditions",
  async (_, thunkAPI) => {
    const token = localStorage.getItem("idToken");

    if (!token) {
      return thunkAPI.rejectWithValue("No authentication token found.");
    }

    try {
      const response = await getTermsAndConditionsService(token);
      return { terms: response.data };
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateTermsAndConditions = createAsyncThunk(
  "termsAndConditions/updateTermsAndConditions",
  async (data: Object, thunkAPI) => {
    const token = localStorage.getItem("idToken");

    if (!token) {
      return thunkAPI.rejectWithValue("No authentication token found.");
    }

    try {
      const response = await updateTermsAndConditionsService(token, data);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error || "Failed to update terms and conditions"
      );
    }
  }
);

const termsAndConditionsSlice = createSlice({
  name: "termsAndConditions",
  initialState: {
    termsAndConditions: {} as TermsAndConditions,
    status: "idle",
    error: null,
  } as TermsAndConditionsState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTermsAndConditions.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(
        getTermsAndConditions.fulfilled,
        (state, action: PayloadAction<TermsAndConditions>) => {
          state.status = "succeeded";
          state.termsAndConditions = action.payload;
        }
      )
      .addCase(getTermsAndConditions.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      })
      .addCase(updateTermsAndConditions.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(
        updateTermsAndConditions.fulfilled,
        (state, action: PayloadAction<TermsAndConditions>) => {
          state.status = "succeeded";
          state.termsAndConditions = action.payload;
        }
      )
      .addCase(updateTermsAndConditions.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      });
  },
});

export const termsAndConditionsReducer = termsAndConditionsSlice.reducer;
